var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4IntePerc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;opacity:0.11;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,2.09A32.91,32.91,0,1,0,67.91,35,32.94,32.94,0,0,0,35,2.09Zm0,64.34A31.43,31.43,0,1,1,66.43,35,31.47,31.47,0,0,1,35,66.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4IntePerc);
export default __webpack_public_path__ + "static/media/4_inte-perc.55342882bf1bfa94fe14dd5250b8c51d.svg";
export { ForwardRef as ReactComponent };